import { createApiClient, responseData } from '#lib/api/client.js';
import type { operations } from '#lib/api/generated/schema.js';

export type ArtistSectionParams =
	operations['getArtistExhibitions']['parameters']['query'];

// One key factory for all five sections, shared between the universal load
// that seeds the first page and the component's own infinite query, so the
// seeded page is found rather than refetched.
export const artistSectionQueryKey = (
	section: string,
	slug: string,
	params: ArtistSectionParams
) => ['artist-section', section, slug, params];

// Written out per section rather than through one generic helper: the paths
// have different response shapes (books carries a total, the rest do not), and
// a generic that takes the path as a parameter collapses them all to whichever
// path types the signature.
export const getArtistExhibitions = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string,
	query: ArtistSectionParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/artist/{slug}/exhibitions',
			{ params: { path: { slug }, query } }
		)
	);

export const getArtistTalks = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string,
	query: ArtistSectionParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/artist/{slug}/talks',
			{ params: { path: { slug }, query } }
		)
	);

export const getArtistPodcasts = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string,
	query: ArtistSectionParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/artist/{slug}/podcasts',
			{ params: { path: { slug }, query } }
		)
	);

export const getArtistNfts = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string,
	query: ArtistSectionParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/artist/{slug}/nfts',
			{ params: { path: { slug }, query } }
		)
	);

export const getArtistBooks = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string,
	query: ArtistSectionParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/artist/{slug}/books',
			{ params: { path: { slug }, query } }
		)
	);
